import { render, staticRenderFns } from "./WeekResourcing.vue?vue&type=template&id=5a86ec13&scoped=true&"
import script from "./WeekResourcing.vue?vue&type=script&lang=ts&"
export * from "./WeekResourcing.vue?vue&type=script&lang=ts&"
import style0 from "./WeekResourcing.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WeekResourcing.vue?vue&type=style&index=1&id=5a86ec13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a86ec13",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VChip,VCol,VContainer,VDatePicker,VDivider,VFabTransition,VForm,VIcon,VRow,VSelect,VSpacer,VSwitch})
